import { IWorkspaceAction } from '../../@types/workspaceTypes';
import { ReactElement, useState } from 'react';
import useNominalJournalReport from '../../components/NominalJournal/useNominalJournalReport';
import { useActionCriteria } from '../../utils/useActionProps';

enum NominalJournalWorkspaceActions {
  NominalJournalReport = 'NOMINAL_JOURNAL_REPORT',
}

export const workspaceActionsForPermissions: Array<IWorkspaceAction> = [
  {
    actionReference: NominalJournalWorkspaceActions.NominalJournalReport,
  },
];

export const useNominalJournalWorkspaceActions = (): [actions: Array<IWorkspaceAction>, modals: ReactElement] => {
  const actionCriteria = useActionCriteria();
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const nominalReportJournalModal = useNominalJournalReport({
    dynamicReportModalOpen: reportModalOpen,
    setDynamicReportModalOpen: setReportModalOpen,
    actionCriteria: actionCriteria,
  });

  const actions: Array<IWorkspaceAction> = [
    {
      actionReference: NominalJournalWorkspaceActions.NominalJournalReport,
      key: 'nominal_journal_report',
      text: 'Nominal Journal Report',
      onClick: () => {
        setReportModalOpen(true);
      },
    },
  ];

  return [actions, nominalReportJournalModal];
};
